import React from 'react';

import { images } from '../../constants';
import './AboutUs.css';

const AboutUs = () => (
  <div className="app__aboutus app__bg flex__center section__padding" id="about">

    <div className="app__aboutus-content flex__center">
      <div className="app__aboutus-content_about">
        <h1 className="headtext__cormorant">About Us</h1>
        <hr style={{ width: '35%', height: '1px', backgroundColor: 'rgb(232 183 3)' }} />
        <p className="p__opensans"> We are a professional beauty parlor salon dedicated to providing exceptional beauty services in a relaxing and welcoming environment. Our skilled team of beauty experts offers a wide range of services, including hair styling, makeup, skincare, and nail care, to help our clients feel confident and beautiful. Visit us for a pampering experience! </p>
        {/* <button type="button" className="custom__button">Know More</button> */}
      </div>

      <div className="app__aboutus-content_knife flex__center">
        <img src={images.knife} alt="about_knife" />
      </div>

      <div className="app__aboutus-content_history">
        <h1 className="headtext__cormorant">Our History</h1>
        <hr style={{ width: '35%', height: '1px', backgroundColor: 'rgb(232 183 3)' }} />
        <p className="p__opensans">For over a decade, our beauty salon has been a trusted destination for all things beauty. With skilled stylists, cutting-edge treatments, and a welcoming atmosphere, we have helped clients feel confident and fabulous. From hair makeovers to spa indulgences, our 12+ year old shop has been a go-to for beauty enthusiasts seeking top-notch service. Thank you for your continued support</p>
        {/* <button type="button" className="custom__button">Know More</button> */}
      </div>
    </div>
  </div>
);

export default AboutUs;
